export default __webpack_public_path__ + "static/media/know-customers.8e992b88.png";